<template>
    <div class = "layout-document ">
        <p>{{documentType}}</p>
        <div class="row">
            <img class ='icons-document col-2 col-sm-1'
              :src="require('@/assets/icons/icon-file.svg')"
              alt="bell icon"
            /> 
            <a :href=objectUrl :download=fileName class = 'btn-grey mr-3 col-4 col-sm-3 col-md-2'><b>DESCARGAR</b></a>
            <button  class = 'btn-grey col-4 col-sm-3 col-md-2' @click="showBlockChain()" ><b>BLOCK CHAIN</b></button>
        </div>
    </div>
</template>

<script>
import {b64toBlob} from '@/services/helper'
export default {
  name: 'DocumentDetail',
  props: [ 'id','blockchain','binary','contentType','documentType','fileName'],
   data(){
    return {
        objectUrl: '',
     }
  },
  mounted () {
    var blob = b64toBlob(this.binary,this.contentType)
    this.objectUrl = URL.createObjectURL(blob);
  },
  methods: {
    showBlockChain: function () {
        this.$parent.showDataBlockChain = true
        this.$store.commit('container/set_blockchain', this.blockchain)
    }
  }
}
</script>

<style lang= "scss" scoped>
  .btn-grey {
    padding: 1.175rem 0.6rem !important;
  }
  .btn-grey:hover{
    color: $text-buttons;
  }
</style>
